<template>
  <div>
    <div class="content-group">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.content-group {
  margin: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e2e2;
}
</style>